import { useState } from 'react';
import styles from './batchPdfDownloadModal.module.css';
import ScreenModal from '../ScreenModal/screenModal';
import Button from '../Button/button';
import Checkbox from '../Checkbox';

export interface BatchPdfDownloadModalProps {
  totalDocumentQuantity: number;
  targetDocumentQuantity: number;
  onCancel: (e: React.MouseEvent<HTMLButtonElement>) => void
  onSubmit: (shouldIncludePreviousVersions: boolean, shouldIncludeAttachmentFiles: boolean) => void
}

function BatchPdfDownloadModal(props: BatchPdfDownloadModalProps) {
  const {
    totalDocumentQuantity,
    targetDocumentQuantity,
    onCancel,
    onSubmit,
  } = props;
  const [shouldIncludePreviousVersions, setShouldIncludePreviousVersions] = useState(false);
  const [shouldIncludeAttachmentFiles, setShouldIncludeAttachmentFiles] = useState(false);

  return (
    <ScreenModal
      customStyles={{
        minWidth: '650px',
        maxHeight: '85%',
        border: 'var(--defaultBorder)',
        display: 'flex',
        flexDirection: 'column',
        color: 'initial',
      }}
    >
      <div className={styles['modal-body']}>
        <p className={styles.textAlignCenter}>PDFファイルを一括ダウンロードしますか？</p>
        <div className={styles.description}>
          <div>
            <p>
              対象件数：
              {targetDocumentQuantity}
              件
            </p>
            <p>
              ※現在ページ内に表示中の
              {totalDocumentQuantity}
              件のうち、PDFが登録済みの文書のみが対象です。
            </p>
            <p>※ファイルサイズが大きい場合、ダウンロード用のzipファイルが分割されます。</p>
          </div>
          <div>
            <p>追加ダウンロード：</p>
            <div className={styles.form}>
              <Checkbox
                label="旧版"
                value={shouldIncludePreviousVersions}
                onChange={setShouldIncludePreviousVersions}
              />
              <Checkbox
                label="添付ファイル"
                value={shouldIncludeAttachmentFiles}
                onChange={setShouldIncludeAttachmentFiles}
              />
            </div>
          </div>
        </div>
        <div>
          <p className={styles.textAlignCenter}>ダウンロード準備完了後、メールでダウンロードURLをお知らせします。</p>
          <p className={styles.textAlignCenter}>※通知メールはほかの管理ユーザーにも送信されます。</p>
        </div>
      </div>
      <div className={styles['modal-footer']}>
        <Button size="smaller" color="lighterGray" onClick={onCancel}>キャンセル</Button>
        <Button size="smaller" onClick={() => onSubmit(shouldIncludePreviousVersions, shouldIncludeAttachmentFiles)}>ダウンロード</Button>
      </div>
    </ScreenModal>
  );
}

export default BatchPdfDownloadModal;
